var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelSubscription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1084 18.75L18.75 2.1084L17.8916 1.25L15.4459 3.69575L13.0432 1.50136H2.8761V16.2655L1.25 17.8916L2.1084 18.75ZM13.4143 5.72726V3.48507L14.5865 4.55515L13.4143 5.72726ZM4.09019 2.71545H12.2002V6.94135L9.2077 9.9339V9.39295H6.67607V10.607H8.53455L4.09019 15.0514L4.09019 2.71545Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.547 18.4987H18.0522V6.34558H16.8381V17.2846H5.547V18.4987Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8257 9.39313H14.2526V10.6075H12.8257V9.39313Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65063 12.5737H14.2519V13.7881H9.65063V12.5737Z",
    fill: "#777777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67432 6.21063H11.0712V7.42501H6.67432V6.21063Z",
    fill: "#777777"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSubscription);
export default __webpack_public_path__ + "static/media/cancel-subscription.163aa8fc226a1a75ef3644116e2ba865.svg";
export { ForwardRef as ReactComponent };